import { render } from "./BasicLayout.vue?vue&type=template&id=4077bf44"
const script = {}
script.render = render

export default script